import { Container, Typography, Box, Paper, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Hero from "../components/UI/Hero";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("seo.title.privacy_policy")}</title>
        <meta
          name="description"
          content={t("seo.description.privacy_policy")}
        />
        <meta property="og:title" content={t("seo.title.privacy_policy")} />
        <meta
          property="og:description"
          content={t("seo.description.privacy_policy")}
        />
      </Helmet>
      <Hero
        title={t("hero.privacy_policy.title")}
        subtitle={t("hero.privacy_policy.subtitle")}
      />
      <Container maxWidth="md" sx={{ my: 10 }}>
        <Box sx={{ mt: 5 }}>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 2, display: "block" }}
          >
            Pēdējoreiz atjaunots: 2025. gads
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            1. Ievads un datu pārzinis
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            Laipni lūdzam vietnē https://cenaudze.lv (turpmāk — “mēs”, “mūsu”
            vai “mūs”), ko pārvalda Cenaudze SIA. Mēs esam personas datu
            pārzinis, kas atbild par šajā privātuma politikā aprakstīto personas
            datu apstrādi.
            <br />
            <br />
            Mēs cienām jūsu privātumu un esam apņēmušies aizsargāt jūsu personas
            datus. Šī privātuma politika izskaidro, kā mēs rīkojamies ar jūsu
            datiem, kad apmeklējat mūsu vietni, kā arī informē par jūsu tiesībām
            un par to, kā likums jūs aizsargā.
          </Typography>
        </Box>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          2. Kontaktinformācija
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Juridiskās personas pilns nosaukums: Cenaudze SIA
          <br />
          E-pasts: info@cenaudze.lv
          <br />
          Pasta adrese: Saldus novads, Zirņu pagasts, “Jaunsērži” <br />
          <br />
          Jums ir tiesības iesniegt sūdzību atbilstošajai uzraudzības iestādei
          jūsu dzīvesvietas valstī.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          3. Mēs apkopojam šādus datus par jums
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          3.1. Identifikācijas un kontaktinformācija
          <br />
          Tostarp jūsu vārds, e-pasta adrese, pasta adrese un tālruņa numurs.
          <br />
          <br />
          3.4. Profila dati
          <br />
          Tostarp jūsu lietotājvārds un parole, intereses, izvēles, atsauksmes
          un aptauju atbildes.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          4. Personas datu apstrādes juridiskais pamats
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Mēs apstrādājam jūsu personas datus tikai tad, ja to pieļauj likums.
          Visbiežāk tas notiek šādos gadījumos:
          <br />
          - ja nepieciešams izpildīt līgumu, ko esam noslēguši vai plānojam
          noslēgt ar jums;
          <br />
          - ja apstrāde nepieciešama mūsu leģitīmo interešu īstenošanai, un jūsu
          tiesības un brīvības nepārsniedz šos interešu apsvērumus;
          <br />
          - ja mums ir pienākums ievērot tiesiskās vai normatīvās prasības;
          <br />- ja esat devis savu piekrišanu.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          5. Datu glabāšanas termiņš
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Mēs glabāsim jūsu personas datus tikai tik ilgi, cik nepieciešams, lai
          izpildītu mērķus, kuru dēļ tie tika apkopoti, tostarp likumā noteikto,
          grāmatvedības vai ziņošanas pienākumu izpildei.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          6. Jūsu tiesības saskaņā ar GDPR
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Jums ir šādas tiesības:
          <br />
          - Tiesības tikt informētam;
          <br />
          - Piekļuves tiesības;
          <br />
          - Tiesības uz labošanu;
          <br />
          - Tiesības uz dzēšanu (“tiesības tikt aizmirstam”);
          <br />
          - Tiesības ierobežot apstrādi;
          <br />
          - Tiesības uz datu pārnesamību;
          <br />
          - Tiesības iebilst pret apstrādi;
          <br />- Tiesības, kas saistītas ar automatizētu lēmumu pieņemšanu un
          profilēšanu.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          7. Datu pārsūtīšana uz ārpus EEZ valstīm
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Mēs varam pārsūtīt jūsu personas datus uz valstīm ārpus Eiropas
          Ekonomikas zonas (EEZ). Ja tas notiek, mēs nodrošinām līdzvērtīgu
          aizsardzības līmeni, ieviešot atbilstošus drošības pasākumus.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          8. Trešo pušu saites
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Mūsu vietnē var būt saites uz trešo pušu tīmekļa vietnēm. Noklikšķinot
          uz šādām saitēm, trešās puses var vākt vai kopīgot datus par jums. Mēs
          nekontrolējam šīs vietnes un neesam atbildīgi par to privātuma
          politikām.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          9. Sīkdatnes (Cookies)
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Jūs varat iestatīt savu pārlūkprogrammu, lai tā atteiktos no visām vai
          daļas sīkdatnēm, vai brīdinātu jūs, kad vietne mēģina tās iestatīt vai
          piekļūt tām. Ja atspējosiet sīkdatnes, dažas mūsu vietnes daļas var
          nedarboties pareizi vai kļūt nepieejamas.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          10. Izmaiņas šajā privātuma politikā
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Laiku pa laikam mēs varam atjaunināt šo privātuma politiku. Par
          izmaiņām mēs informēsim, publicējot jauno versiju šajā lapā.
        </Typography>

        <Typography
          color="primary"
          variant="h3"
          sx={{ mb: 2, display: "block" }}
        >
          11. Politikas pieņemšana
        </Typography>
        <Typography
          color="primary"
          variant="body"
          sx={{ mb: 5, display: "block" }}
        >
          Izmantojot mūsu vietni, jūs apliecināt, ka esat izlasījis un sapratis
          šo privātuma politiku un piekrītat tās nosacījumiem.
        </Typography>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
